import { render } from "./UserPreferencesWidget.vue?vue&type=template&id=72daaa2d"
import script from "./UserPreferencesWidget.vue?vue&type=script&lang=js"
export * from "./UserPreferencesWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__